module.exports = __webpack_public_path__ + "a03ed90208197244020d30d1f382eaf9.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/798.png
// module id = 1704
// module chunks = 2